import * as RadixRadioGroup from "@radix-ui/react-radio-group";
import clsx from "clsx";

export function RadioGroupItem({ children, disabled, className, ...rest }: RadixRadioGroup.RadioGroupItemProps) {
  return (
    <RadixRadioGroup.Item
      {...rest}
      className={clsx(className, "bg-background-input", "rounded-full", "w-7", "h-7", "flex", "items-stretch")}
      disabled={disabled}
    >
      <div className={clsx("flex", "rounded-full", "grow", "bg-white", "m-px", "border-2", "border-blue-grey-200")}>
        {children}
      </div>
    </RadixRadioGroup.Item>
  );
}
